import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const TemplateExecutors = lazy(() => import('./TemplateExecutors'));

const TemplateExecutorsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.admin,
  routes: [
    {
      path: 'admin/document-template-executors',
      element: <TemplateExecutors />,
    },
  ],
};

export default TemplateExecutorsConfig;
